import React, { useEffect, useState } from "react"
import { Col, Row, Switch } from "antd"
import Cookies from "js-cookie"
import ReactTooltip from "react-tooltip"

import { StyledModal, Title, Message, CookiesDiv, ColumnDiv } from "./styled"
import { COOKIES } from "../../enum"

interface Props {
  visible: boolean
  onOk?: () => void
  onCancel?: () => void
  closable?: boolean
  maskClosable?: boolean
}

const CustomCookieModal: React.FC<Props> = ({
  visible,
  onOk,
  onCancel,
  closable,
  maskClosable,
}) => {
  const cookieState = Cookies.get(COOKIES.PERFORMANCE_COOKIES)
  const [isChecked, setIsChecked] = useState<boolean>()

  const onChange = () => {
    setIsChecked(!isChecked)
  }

  useEffect(() => {
    setIsChecked(cookieState !== "false")
  }, [cookieState])

  return (
    <StyledModal
      centered
      visible={visible}
      onOk={() => {
        Cookies.set(COOKIES.PERFORMANCE_COOKIES, `${isChecked}`)
        if (onOk) onOk()
      }}
      onCancel={onCancel}
      cancelButtonProps={{
        size: "large",
        style: {
          width: "180px",
          textTransform: "uppercase",
        },
      }}
      okButtonProps={{
        size: "large",
        style: {
          textTransform: "uppercase",
        },
      }}
      width={"1000px"}
      cancelText={"Close"}
      okText={"Confirm & Accept"}
      closable={closable}
      maskClosable={maskClosable}
    >
      <Row justify="center">
        <Col>
          <Title>Manage Cookies</Title>
          <Message>
            <p>
              This site uses cookies to function. If you give us your consent,
              we will also use cookies, when you visit our website, which will
              allow us to collect data for aggregated statistics to improve our
              services, analyze web traffic, facilitate our marketing efforts,
              provide you personalized content and advertisements, and the best
              user experience. You may visit our{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="/data-privacy-and-cookies-policy"
                target="_blank"
              >
                Cookies Policy
              </a>{" "}
              page for more information or to change your preferences.
            </p>
          </Message>

          <CookiesDiv style={{ marginBottom: "10px" }}>
            <ColumnDiv style={{ width: "80%" }}>
              <Title>ACCEPT ALL NECESSARY COOKIES</Title>
              <Message>
                These cookies are essential for the operation of this website.
                Without these cookies, our services (e.g. logging in / session
                cookies, adding items to the cart / authentication cookies,
                security cookies) cannot be provided. These cookies expire when
                you close the browser.
              </Message>
            </ColumnDiv>

            <ColumnDiv
              style={{
                width: "20%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Title>Always Active</Title>
            </ColumnDiv>
          </CookiesDiv>

          <CookiesDiv style={{ marginBottom: "10px" }}>
            <ColumnDiv style={{ width: "80%" }}>
              <Title>ACCEPT FUNCTIONAL COOKIES</Title>
              <Message>
                These cookies allow the website to personalize your experience
                and remember your preferences (e g username, language preference
                or region-specific cookies). These cookies expire after two (2)
                years or when you clear your browser cookies.
              </Message>
            </ColumnDiv>

            <ColumnDiv
              style={{
                width: "20%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p data-tip="Not available">
                <Switch defaultChecked disabled />
              </p>
              <ReactTooltip place="top" type="dark" effect="float" />
            </ColumnDiv>
          </CookiesDiv>

          <CookiesDiv>
            <ColumnDiv style={{ width: "80%" }}>
              <Title>ACCEPT PERFORMANCE COOKIES</Title>
              <Message>
                These cookies collect information about how you use the website
                (e.g. analytics and measurement cookies, which pages are visited
                most often) but do not collect information that identifies a
                visitor. These cookies expire after two (2) years.
              </Message>
            </ColumnDiv>

            <ColumnDiv
              style={{
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Switch onChange={onChange} checked={isChecked} />
            </ColumnDiv>
          </CookiesDiv>
        </Col>
      </Row>
    </StyledModal>
  )
}

export default CustomCookieModal
